import { defineStore } from 'pinia';
import { ref } from 'vue';

import type {
  ConsentDTO,
  NotificationConsentModalOpenContext,
} from '@nora-monorepo/nora-api-client';
import { useApiStore } from '@nora-monorepo/ui-shared';

export const useConsentModalStore = defineStore('consentModalStore', () => {
  const isShowingConsentModal = ref(false);
  const currentConsent = ref<ConsentDTO>();
  const currentContext = ref<NotificationConsentModalOpenContext | undefined>();
  const consentActionDone = ref<string | null>(null);
  const isError = ref(false);

  const api = useApiStore();

  async function showConsentModal(
    consentId: string,
    context?: NotificationConsentModalOpenContext,
  ): Promise<void> {
    isShowingConsentModal.value = true;
    let consentData;

    try {
      consentData = await api.unwrap(
        api.consent.getUserConsentById({ consentId }),
      );
      if (!consentData.data) {
        throw new Error('Consent data not found');
      }
    }
    catch (error) {
      console.error('Error fetching consent:', error);
      isError.value = true;
      return;
    }

    currentConsent.value = consentData.data;
    currentContext.value = context;
  }

  const closeModal = (): void => {
    isShowingConsentModal.value = false;
    isError.value = false;
  };

  return {
    currentConsent,
    currentContext,
    consentActionDone,
    isShowingConsentModal,
    isError,
    showConsentModal,
    closeModal,
  };
});
